export class Contact {
  name: string;
  address: string;
  phone: string;
  email: string;
  fax: string;
}